import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";

@Injectable()

export class RecursiveService {

    constructor(private http: HttpClient, private router: Router){}

    routes = {
        product: {route: '/api/products/'},
        menu: {route: '/api/menus/'},
        delivery: {route: '/api/delivery/items/'},
    };

    // receive a item to put, return observable to handle
    // TODO pass this url as a input in the component
    saveItem(item){
        let route = '';
        if (item.items === null) {
            item.items = [];
            for (let object of item.items){
                if (object.related === null) {

                }
            }
        }else {
            for (let object of item.items){
                if (object.related === null) {

                }
            }
        }

        if (this.router.url.startsWith('/crud/menus')){
            route = this.routes.menu.route
        }else {
            route = this.routes.delivery.route
        }
        if (item.productionPointId === 111){
            item.productionPointId = null;
            return this.http.put<any>(route + item._id, item);
        }else {
            return this.http.put<any>(route + item._id, item);

        }
    }

    // return available groups
    getGroups(){
        return this.http.get<any>('/api/menus/groups/?page=1&limit=999');
    }

    // receive form data, returns observable to handle
    postImage(formData){
        return this.http.post<any>('/api/files', formData)
    }

    //receive item to post, return observable to handle
    postItem(item){
        let route = '';
        if (this.router.url.startsWith('/crud/menus')){
            route = this.routes.menu.route;
            item.hasDelivery = false;
        }else {
            route = this.routes.delivery.route;
            item.hasDelivery = true;

        }
        return this.http.post<any>(route, item);
    }

    deleteMenu(item){
        console.log(item, 'to delete');
       return this.http.delete<any>(this.routes.delivery.route + item._id);
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/customs/recursive/recursive.service.ts